// import React, { useState, useEffect } from "react";
// import { useSelector } from "react-redux";
// import axios from "axios";
// import { toast } from "react-toastify";
// import {
//   FiSettings,
//   FiClock,
//   FiSave,
//   FiLoader,
//   FiCheckCircle,
//   FiAlertCircle,
//   FiRefreshCw,
//   FiServer,
//   FiZap,
// } from "react-icons/fi";
// import { SETTINGS_API, INTEGRATIONS_API } from "../api/apiroutes";

// const Setting = () => {
//   const token = useSelector((state) => state.user.token);

//   // Form state
//   const [skipMinute, setSkipMinute] = useState("");
//   const [timePeriod, setTimePeriod] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState(null);
//   const [success, setSuccess] = useState(false);

//   // Integrations state
//   const [integrations, setIntegrations] = useState([]);
//   const [integrationsLoading, setIntegrationsLoading] = useState(false);

//   // Fetch current settings and integrations on mount
//   useEffect(() => {
//     fetchSettings();
//     fetchIntegrations();
//   }, []);

//   const fetchSettings = async () => {
//     if (!token) return;

//     setLoading(true);
//     setError(null);

//     try {
//       const response = await axios.get(SETTINGS_API.GET, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "x-client-type": "web",
//           "Content-Type": "application/json",
//         },
//       });

//       // Handle response structure: { code: 200, data: { skipMinutes, trialPeriod } }
//       if (response.data?.code === 200 && response.data?.data) {
//         const data = response.data.data;
//         // Map API response fields to component state
//         setSkipMinute(data.skipMinutes?.toString() || "");
//         setTimePeriod(data.trialPeriod?.toString() || "");
//       } else if (response.data?.data) {
//         // Fallback for different response structure
//         const data = response.data.data;
//         setSkipMinute(data.skipMinutes?.toString() || "");
//         setTimePeriod(data.trialPeriod?.toString() || "");
//       }
//     } catch (err) {
//       console.error("Failed to fetch settings", err);
//       const errorMessage =
//         err.response?.data?.message ||
//         err.message ||
//         "Failed to load settings. Using default values.";
//       setError(errorMessage);
//       if (err.response?.status !== 404) {
//         toast.error(errorMessage);
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchIntegrations = async () => {
//     if (!token) return;

//     setIntegrationsLoading(true);

//     try {
//       const response = await axios.get(INTEGRATIONS_API.GET, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "x-client-type": "web",
//           "Content-Type": "application/json",
//         },
//       });

//       // Handle response structure: { code: 200, data: { integrations: [...] } }
//       if (response.data?.code === 200 && response.data?.data?.integrations) {
//         setIntegrations(response.data.data.integrations);
//       } else if (response.data?.integrations) {
//         setIntegrations(response.data.integrations);
//       }
//     } catch (err) {
//       console.error("Failed to fetch integrations", err);
//       // Don't show error toast for integrations, just log it
//     } finally {
//       setIntegrationsLoading(false);
//     }
//   };

//   const handleSave = async () => {
//     if (!token) {
//       toast.error("Authentication required");
//       return;
//     }

//     // Validation
//     if (!skipMinute || !timePeriod) {
//       toast.error("Please fill in all fields");
//       return;
//     }

//     const skipMinuteNum = parseInt(skipMinute);
//     const timePeriodNum = parseInt(timePeriod);

//     if (isNaN(skipMinuteNum) || skipMinuteNum < 0) {
//       toast.error("Skip minute must be a valid positive number");
//       return;
//     }

//     if (isNaN(timePeriodNum) || timePeriodNum < 0) {
//       toast.error("Time period must be a valid positive number");
//       return;
//     }

//     setSaving(true);
//     setError(null);
//     setSuccess(false);

//     try {
//       // Map component state to API request format
//       const requestBody = {
//         skipMinutes: skipMinuteNum, // API expects skipMinutes (plural)
//         trialPeriod: timePeriodNum, // API expects trialPeriod
//       };

//       const response = await axios.put(SETTINGS_API.UPDATE, requestBody, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "x-client-type": "web",
//           "Content-Type": "application/json",
//         },
//       });

//       // Handle response structure: { code: 200, data: { skipMinutes, trialPeriod } }
//       if (response.data?.code === 200 || response.status === 200) {
//         setSuccess(true);
//         toast.success("Settings saved successfully!");

//         // Update local state with response data if available
//         if (response.data?.data) {
//           const data = response.data.data;
//           setSkipMinute(data.skipMinutes?.toString() || skipMinute);
//           setTimePeriod(data.trialPeriod?.toString() || timePeriod);
//         }

//         // Hide success message after 3 seconds
//         setTimeout(() => {
//           setSuccess(false);
//         }, 3000);
//       }
//     } catch (err) {
//       console.error("Failed to save settings", err);
//       const errorMessage =
//         err.response?.data?.message ||
//         err.message ||
//         "Failed to save settings. Please try again.";
//       setError(errorMessage);
//       toast.error(errorMessage);
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 p-6">
//       <div className="max-w-4xl mx-auto space-y-6">
//         {/* Header Section - Reduced padding */}
//         <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-4">
//           <div className="flex items-center justify-between">
//             <div>
//               <h1 className="text-2xl font-bold text-gray-900">
//                 Settings
//               </h1>
//               <p className="text-sm text-gray-600 mt-1">
//                 Configure system settings and preferences
//               </p>
//             </div>
//             <div className="p-3 bg-gradient-to-br from-amber-500 to-orange-600 rounded-xl">
//               <FiSettings className="text-white" size={24} />
//             </div>
//           </div>
//         </div>

//         {/* Integrations Cards Section */}
//         <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
//           <div className="px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-gray-50 to-white">
//             <div className="flex items-center justify-between">
//               <div>
//                 <h2 className="text-xl font-semibold text-gray-900 flex items-center gap-2">
//                   <FiServer className="text-indigo-500" size={20} />
//                   Integrations
//                 </h2>
//                 <p className="text-sm text-gray-600 mt-1">
//                   Manage connected services and device integrations
//                 </p>
//               </div>
//               {!integrationsLoading && (
//                 <button
//                   onClick={fetchIntegrations}
//                   className="px-3 py-1.5 text-sm bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-200 flex items-center gap-2 text-gray-700"
//                 >
//                   <FiRefreshCw size={16} />
//                   Refresh
//                 </button>
//               )}
//             </div>
//           </div>

//           {integrationsLoading ? (
//             <div className="text-center py-12">
//               <FiLoader
//                 className="mx-auto text-blue-600 animate-spin"
//                 size={32}
//               />
//               <p className="mt-3 text-gray-600 text-sm">Loading integrations...</p>
//             </div>
//           ) : integrations.length > 0 ? (
//             <div className="p-6">
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 {integrations.map((integration) => (
//                   <IntegrationCard
//                     key={integration._id}
//                     integration={integration}
//                   />
//                 ))}
//               </div>
//             </div>
//           ) : (
//             <div className="text-center py-12">
//               <FiServer className="mx-auto text-gray-400" size={48} />
//               <p className="mt-4 text-gray-600">No integrations available</p>
//             </div>
//           )}
//         </div>

//         {/* Settings Form Card */}
//         <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
//           <div className="px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-gray-50 to-white">
//             <div className="flex items-center justify-between">
//               <div>
//                 <h2 className="text-xl font-semibold text-gray-900 flex items-center gap-2">
//                   <FiSettings className="text-amber-500" size={20} />
//                   Configuration Settings
//                 </h2>
//                 <p className="text-sm text-gray-600 mt-1">
//                   Update system configuration values
//                 </p>
//               </div>
//               {!loading && (
//                 <button
//                   onClick={fetchSettings}
//                   className="px-3 py-1.5 text-sm bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-200 flex items-center gap-2 text-gray-700"
//                 >
//                   <FiRefreshCw size={16} />
//                   Refresh
//                 </button>
//               )}
//             </div>
//           </div>

//           {loading ? (
//             <div className="text-center py-16">
//               <FiLoader
//                 className="mx-auto text-blue-600 animate-spin"
//                 size={48}
//               />
//               <p className="mt-4 text-gray-600">Loading settings...</p>
//             </div>
//           ) : (
//             <div className="p-6 space-y-6">
//               {/* Success Message */}
//               {success && (
//                 <div className="p-4 bg-emerald-50 border border-emerald-200 rounded-lg flex items-center gap-3 animate-fade-in">
//                   <FiCheckCircle className="text-emerald-600" size={20} />
//                   <div>
//                     <p className="font-semibold text-emerald-900">
//                       Settings Saved Successfully!
//                     </p>
//                     <p className="text-sm text-emerald-700">
//                       Your configuration has been updated.
//                     </p>
//                   </div>
//                 </div>
//               )}

//               {/* Error Message */}
//               {error && (
//                 <div className="p-4 bg-red-50 border border-red-200 rounded-lg flex items-center gap-3">
//                   <FiAlertCircle className="text-red-600" size={20} />
//                   <div className="flex-1">
//                     <p className="font-semibold text-red-900">Error</p>
//                     <p className="text-sm text-red-700">{error}</p>
//                   </div>
//                   <button
//                     onClick={() => setError(null)}
//                     className="text-red-600 hover:text-red-800"
//                   >
//                     <FiAlertCircle size={20} />
//                   </button>
//                 </div>
//               )}

//               {/* Skip Minute Field */}
//               <div className="space-y-2">
//                 <label
//                   htmlFor="skipMinute"
//                   className="flex items-center gap-2 text-sm font-semibold text-gray-700"
//                 >
//                   <FiClock className="text-blue-600" size={16} />
//                   Skip Minute
//                 </label>
//                 <div className="relative">
//                   <input
//                     id="skipMinute"
//                     type="number"
//                     min="0"
//                     step="1"
//                     value={skipMinute}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       // Only allow numbers and empty string
//                       if (value === "" || /^\d+$/.test(value)) {
//                         const numValue = value === "" ? "" : parseInt(value);
//                         if (value === "" || (numValue >= 0 && !isNaN(numValue))) {
//                           setSkipMinute(value);
//                         }
//                       }
//                     }}
//                     onKeyDown={(e) => {
//                       // Prevent negative sign, decimal point, and 'e', 'E', '+'
//                       if (e.key === "-" || e.key === "." || e.key === "e" || e.key === "E" || e.key === "+") {
//                         e.preventDefault();
//                       }
//                     }}
//                     placeholder="Enter skip minute value"
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 text-gray-900 placeholder-gray-400 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [-moz-appearance:textfield]"
//                     style={{ paddingRight: '5.5rem' }}
//                   />
//                   <div className="absolute right-4 top-1/2 -translate-y-1/2 text-sm text-gray-500 pointer-events-none">
//                     minutes
//                   </div>
//                 </div>
//                 <p className="text-xs text-gray-500">
//                   Set the skip minute value for schedule processing
//                 </p>
//               </div>

//               {/* Time Period Field */}
//               <div className="space-y-2">
//                 <label
//                   htmlFor="timePeriod"
//                   className="flex items-center gap-2 text-sm font-semibold text-gray-700"
//                 >
//                   <FiClock className="text-purple-600" size={16} />
//                   Time Period
//                 </label>
//                 <div className="relative">
//                   <input
//                     id="timePeriod"
//                     type="number"
//                     min="0"
//                     step="1"
//                     value={timePeriod}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       // Only allow numbers and empty string
//                       if (value === "" || /^\d+$/.test(value)) {
//                         const numValue = value === "" ? "" : parseInt(value);
//                         if (value === "" || (numValue >= 0 && !isNaN(numValue))) {
//                           setTimePeriod(value);
//                         }
//                       }
//                     }}
//                     onKeyDown={(e) => {
//                       // Prevent negative sign, decimal point, and 'e', 'E', '+'
//                       if (e.key === "-" || e.key === "." || e.key === "e" || e.key === "E" || e.key === "+") {
//                         e.preventDefault();
//                       }
//                     }}
//                     placeholder="Enter time period value"
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all duration-200 text-gray-900 placeholder-gray-400 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [-moz-appearance:textfield]"
//                     style={{ paddingRight: '4.5rem' }}
//                   />
//                   <div className="absolute right-4 top-1/2 -translate-y-1/2 text-sm text-gray-500 pointer-events-none">
//                     days
//                   </div>
//                 </div>
//                 <p className="text-xs text-gray-500">
//                   Set the time period for schedule execution (in days)
//                 </p>
//               </div>

//               {/* Action Buttons */}
//               <div className="flex items-center justify-end gap-3 pt-4 border-t border-gray-200">
//                 <button
//                   onClick={handleSave}
//                   disabled={saving || !skipMinute || !timePeriod}
//                   className="px-6 py-2.5 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg hover:from-blue-700 hover:to-indigo-700 disabled:from-gray-400 disabled:to-gray-500 disabled:cursor-not-allowed transition-all duration-200 font-medium shadow-md hover:shadow-lg flex items-center gap-2"
//                 >
//                   {saving ? (
//                     <>
//                       <FiLoader className="animate-spin" size={18} />
//                       Saving...
//                     </>
//                   ) : (
//                     <>
//                       <FiSave size={18} />
//                       Save Settings
//                     </>
//                   )}
//                 </button>
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Info Card */}
//         <div className="bg-blue-50 border-2 border-blue-200 rounded-xl p-5">
//           <div className="flex items-start gap-3">
//             <div className="p-2 bg-blue-100 rounded-lg">
//               <FiAlertCircle className="text-blue-600" size={20} />
//             </div>
//             <div>
//               <h3 className="font-semibold text-blue-900 mb-1">
//                 Settings Information
//               </h3>
//               <p className="text-sm text-blue-700">
//                 Changes to these settings will affect system behavior. Please
//                 ensure values are correct before saving. All fields are
//                 required.
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// /* ---------------- Integration Card Component ---------------- */
// function IntegrationCard({ integration }) {
//   const deviceTypes = Array.isArray(integration.meta?.deviceType)
//     ? integration.meta.deviceType
//     : integration.meta?.deviceType
//     ? [integration.meta.deviceType]
//     : [];

//   const integrations = Array.isArray(integration.meta?.integration)
//     ? integration.meta.integration
//     : integration.meta?.integration
//     ? [integration.meta.integration]
//     : [];

//   return (
//     <div
//       className={`bg-gradient-to-br from-white to-gray-50 border-2 rounded-xl p-5 hover:shadow-lg transition-all duration-200 ${
//         integration.connected
//           ? "border-emerald-200 bg-emerald-50/30"
//           : "border-gray-200"
//       }`}
//     >
//       <div className="flex items-start justify-between mb-4">
//         <div className="flex items-center gap-3 flex-1">
//           {/* Integration Icon */}
//           {integration.icon ? (
//             <div className="w-12 h-12 rounded-lg bg-white border border-gray-200 p-2 flex items-center justify-center overflow-hidden">
//               <img
//                 src={integration.icon}
//                 alt={integration.brand}
//                 className="w-full h-full object-contain"
//                 onError={(e) => {
//                   e.target.style.display = "none";
//                   e.target.nextSibling.style.display = "flex";
//                 }}
//               />
//               <div
//                 className="w-full h-full bg-indigo-100 rounded flex items-center justify-center text-indigo-600 font-bold text-xs hidden"
//               >
//                 {integration.brand?.[0] || "I"}
//               </div>
//             </div>
//           ) : (
//             <div className="w-12 h-12 rounded-lg bg-indigo-100 flex items-center justify-center">
//               <FiServer className="text-indigo-600" size={24} />
//             </div>
//           )}

//           <div className="flex-1 min-w-0">
//             <h3 className="font-bold text-gray-900 text-lg truncate">
//               {integration.brand || "Unknown Brand"}
//             </h3>
//             {integration.nickname && (
//               <p className="text-sm text-gray-600 truncate">
//                 {integration.nickname}
//               </p>
//             )}
//           </div>
//         </div>

//         {/* Connection Status Badge */}

//       </div>

//       {/* Meta Information */}
//       <div className="space-y-2 pt-3 border-t border-gray-200">
//         {deviceTypes.length > 0 && (
//           <div className="flex items-start gap-2">
//             <FiZap className="text-gray-500 mt-0.5" size={14} />
//             <div className="flex-1">
//               <p className="text-xs text-gray-500 mb-1">Device Types</p>
//               <div className="flex flex-wrap gap-1">
//                 {deviceTypes.map((type, idx) => (
//                   <span
//                     key={idx}
//                     className="px-2 py-0.5 bg-blue-50 text-blue-700 text-xs font-medium rounded border border-blue-200"
//                   >
//                     {type}
//                   </span>
//                 ))}
//               </div>
//             </div>
//           </div>
//         )}

//         {integrations.length > 0 && (
//           <div className="flex items-start gap-2">
//             <FiServer className="text-gray-500 mt-0.5" size={14} />
//             <div className="flex-1">
//               <p className="text-xs text-gray-500 mb-1">Integration Types</p>
//               <div className="flex flex-wrap gap-1">
//                 {integrations.map((type, idx) => (
//                   <span
//                     key={idx}
//                     className="px-2 py-0.5 bg-purple-50 text-purple-700 text-xs font-medium rounded border border-purple-200"
//                   >
//                     {type}
//                   </span>
//                 ))}
//               </div>
//             </div>
//           </div>
//         )}

//         {integration.meta?.category && (
//           <div className="flex items-center gap-2">
//             <span className="text-xs text-gray-500">Category:</span>
//             <span className="px-2 py-0.5 bg-indigo-50 text-indigo-700 text-xs font-medium rounded border border-indigo-200">
//               {integration.meta.category}
//             </span>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default Setting;

import React, { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import {
  FiSettings,
  FiClock,
  FiSave,
  FiLoader,
  FiCheckCircle,
  FiRefreshCw,
  FiGrid,
  FiZap,
  FiActivity,
  FiAlertTriangle,
  FiCpu,
  FiDatabase,
  FiHardDrive,
  FiTriangle,
} from "react-icons/fi";
import { SETTINGS_API, INTEGRATIONS_API } from "../api/apiroutes";

const Setting = () => {
  const { token, roles } = useSelector((state) => state.user);

  const isAdmin = roles?.includes("admin");

  // States
  const [skipMinute, setSkipMinute] = useState("");
  const [timePeriod, setTimePeriod] = useState("");
  const [queueLimit, setQueueLimit] = useState("");
  const [tapoRateLimit, setTapoRateLimit] = useState(5);
  const [honeywellRateLimit, setHoneywellRateLimit] = useState(2);

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);
  const [integrations, setIntegrations] = useState([]);
  const [integrationsLoading, setIntegrationsLoading] = useState(false);
  const [systemInfo, setSystemInfo] = useState({
    lastRamCheck: "",
    systemStatus: "",
    statusReason: "",
    cronActive: false,
    lastPulse: "",
    workerActive: false,
    workerLastPulse: "",
  });

  // API Call: Fetch Settings
  const fetchSettings = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    try {
      const { data } = await axios.get(SETTINGS_API.GET, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      // Correctly mapping based on your previous structure
      const config = data?.data || data;
      setSkipMinute(config.skipMinutes?.toString() || "");
      setTimePeriod(config.trialPeriod?.toString() || "");
      setQueueLimit(config.queueLimit?.toString() || "");
      setTapoRateLimit(config.tapoRateLimit?.toString() || "5");
      setHoneywellRateLimit(config.honeywellRateLimit?.toString() || "2");

      setSystemInfo({
        lastRamCheck: config.lastRamCheck || "N/A",
        systemStatus: config.systemStatus || "unknown",
        statusReason: config.statusReason || "",
        cronActive: config.cronActive || false,
        lastPulse: config.lastPulse || "",
        workerActive: config.workerActive || false,
        workerLastPulse: config.workerLastPulse || "",
      });
    } catch (err) {
      toast.error("Failed to sync settings with server");
      console.error("Fetch Error:", err);
    } finally {
      setLoading(false);
    }
  }, [token]);

  // API Call: Fetch Integrations
  const fetchIntegrations = useCallback(async () => {
    if (!token) return;
    setIntegrationsLoading(true);
    try {
      const { data } = await axios.get(INTEGRATIONS_API.GET, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setIntegrations(data?.data?.integrations || data?.integrations || []);
    } catch (err) {
      console.error("Integrations Error:", err);
    } finally {
      setIntegrationsLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchSettings();
    fetchIntegrations();
  }, [fetchSettings, fetchIntegrations]);

  // API Call: Save Settings
  const handleSave = async () => {
    if (
      !skipMinute ||
      !timePeriod ||
      !queueLimit ||
      !tapoRateLimit ||
      !honeywellRateLimit
    )
      return toast.warning("Fields cannot be empty");

    setSaving(true);
    setSuccess(false);
    try {
      const payload = {
        skipMinutes: Number(skipMinute),
        trialPeriod: Number(timePeriod),
        queueLimit: Number(queueLimit),
        tapoRateLimit: Number(tapoRateLimit),
        honeywellRateLimit: Number(honeywellRateLimit),
      };
      await axios.put(SETTINGS_API.UPDATE, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSuccess(true);
      toast.success("Successfully Configured");
      setTimeout(() => setSuccess(false), 3000);
    } catch (err) {
      toast.error(err.response?.data?.message || "Update Failed");
    } finally {
      setSaving(false);
    }
  };

  const isServiceActive = (pulseTime, isActive) => {
    if (!pulseTime) return false;

    const isStale = Date.now() - new Date(pulseTime).getTime() > 180000;
    if (isStale) return false;

    return isActive;
  };

  // Status Color Logic (3 min staleness)
  const getStatusColor = (pulseTime, isActive) => {
    if (!pulseTime) return "bg-slate-300";
    const isStale = Date.now() - new Date(pulseTime).getTime() > 180000;
    if (isStale) return "bg-red-500 animate-pulse shadow-[0_0_10px_#ef4444]";
    return isActive
      ? "bg-emerald-500 animate-pulse shadow-[0_0_10px_#10b981]"
      : "bg-slate-300";
  };

  return (
    <div className="min-h-screen bg-[#F4F7FE] text-slate-900 p-6 md:p-10 font-sans selection:bg-indigo-500 selection:text-white">
      <div className="max-w-6xl mx-auto space-y-10">
        {/* --- HEADER --- */}
        <div className="flex justify-between items-center bg-white p-6 rounded-[2rem] shadow-sm border border-slate-100">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 bg-indigo-600 rounded-2xl flex items-center justify-center shadow-lg shadow-indigo-200">
              <FiSettings
                className="text-white animate-[spin_8s_linear_infinite]"
                size={28}
              />
            </div>
            <div>
              <h1 className="text-2xl font-black tracking-tight text-slate-800">
                System Configuration
              </h1>
              <p className="text-[10px] font-bold text-slate-400 uppercase tracking-[0.2em]">
                Manage your system settings and integrations
              </p>
            </div>
          </div>
          <button
            onClick={() => {
              fetchSettings();
              fetchIntegrations();
            }}
            className="p-4 bg-slate-50 hover:bg-white hover:shadow-md rounded-2xl transition-all active:scale-90"
          >
            <FiRefreshCw
              className={
                loading ? "animate-spin text-indigo-600" : "text-slate-400"
              }
              size={22}
            />
          </button>
        </div>

        {/* --- HORIZONTAL DOCK --- */}
        <section className="space-y-4">
          <h3 className="text-[11px] font-black text-slate-400 uppercase tracking-[0.3em] flex items-center gap-2 px-2">
            <FiGrid className="text-indigo-500" /> Integrations
          </h3>
          <div className="flex overflow-x-auto gap-4 pb-4 no-scrollbar scroll-smooth">
            {integrationsLoading ? (
              [1, 2, 3].map((n) => (
                <div
                  key={n}
                  className="min-w-[280px] h-24 bg-white/50 rounded-3xl animate-pulse"
                />
              ))
            ) : integrations.length === 0 ? (
              <div className="w-full py-10 bg-white rounded-3xl border-2 border-dashed border-slate-200 flex flex-col items-center justify-center text-slate-400">
                <FiAlertTriangle size={24} className="mb-2" />
                <p className="text-xs font-bold uppercase">
                  No integrations found.
                </p>
              </div>
            ) : (
              integrations.map((item) => (
                <div
                  key={item._id}
                  className="min-w-[280px] bg-white border border-slate-100 p-5 rounded-[2rem] hover:shadow-xl hover:shadow-indigo-100/50 transition-all group cursor-default"
                >
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-slate-50 rounded-xl flex items-center justify-center p-2 group-hover:bg-indigo-50 transition-colors">
                      {item.icon ? (
                        <img
                          src={item.icon}
                          alt=""
                          className="w-full h-full object-contain"
                        />
                      ) : (
                        <FiZap className="text-amber-400" />
                      )}
                    </div>
                    <div className="flex-1 min-w-0">
                      <h4 className="font-black text-slate-800 text-xs uppercase truncate">
                        {item.brand || "Node"}
                      </h4>
                      <p className="text-[10px] font-bold text-indigo-500 truncate">
                        {item.meta?.category || "Utility"}
                      </p>
                    </div>
                    <div
                      className={`w-2 h-2 rounded-full ${item.connected ? "bg-emerald-500 shadow-[0_0_10px_#10b981]" : "bg-slate-200"}`}
                    />
                  </div>
                </div>
              ))
            )}
          </div>
        </section>

        {/* --- MAIN INTERACTIVE CARD --- */}
        <div className="bg-white rounded-[3rem] shadow-2xl shadow-slate-200/50 overflow-hidden border border-slate-100">
          <div
            className={`grid grid-cols-1 ${isAdmin ? "md:grid-cols-3" : "md:grid-cols-2"} divide-y md:divide-y-0 md:divide-x divide-slate-100`}
          >
            {/* Input 01 */}
            <div className="p-10 md:p-12 space-y-6 group">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-violet-50 rounded-xl flex items-center justify-center text-violet-600 shadow-sm">
                  <FiActivity />
                </div>
                <label className="text-xs font-black text-slate-400 uppercase tracking-widest">
                  Trial Window <p>(Global validity period automatically assigned to
                  new users)</p>
                </label>
              </div>
              <div className="relative">
                <input
                  type="number"
                  value={timePeriod}
                  onChange={(e) => setTimePeriod(e.target.value)}
                  className="w-full bg-transparent border-none p-0 font-black text-6xl text-slate-800 focus:ring-0 outline-none placeholder:text-slate-100"
                  placeholder="00"
                />
                <span className="absolute right-0 bottom-2 text-[10px] font-black text-slate-300 tracking-[0.3em]">
                  DAYS
                </span>
              </div>
            </div>

            {/* Input 02 */}
            <div className="p-10 md:p-12 space-y-6 group">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-indigo-50 rounded-xl flex items-center justify-center text-indigo-600 shadow-sm">
                  <FiClock />
                </div>
                <label className="text-xs font-black text-slate-400 uppercase tracking-widest">
                  Downtime Handling <p>(Increase this in case of cron or worker
                  downtime to avoid task failures)</p>
                </label>
              </div>
              <div className="relative">
                <input
                  type="number"
                  value={skipMinute}
                  onChange={(e) => setSkipMinute(e.target.value)}
                  className="w-full bg-transparent border-none p-0 font-black text-6xl text-slate-800 focus:ring-0 outline-none placeholder:text-slate-100"
                  placeholder="00"
                />
                <span className="absolute right-0 bottom-2 text-[10px] font-black text-slate-300 tracking-[0.3em]">
                  MINS
                </span>
              </div>
            </div>

            {/* Input 03 */}
            {isAdmin ? (
              <div className="p-10 md:p-12 space-y-6 group">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-amber-50 rounded-xl flex items-center justify-center text-amber-600 shadow-sm">
                    <FiDatabase />
                  </div>
                  <label className="text-xs font-black text-slate-400 uppercase tracking-widest">
                    Queue Limit <p>(its based on calculations do not set it too
                    high, safe limit is 100)</p>
                  </label>
                </div>
                <div className="relative">
                  <input
                    type="number"
                    value={queueLimit}
                    onChange={(e) => setQueueLimit(e.target.value)}
                    className="w-full bg-transparent border-none p-0 font-black text-6xl text-slate-800 focus:ring-0 outline-none placeholder:text-slate-100"
                    placeholder="00"
                  />
                  <span className="absolute right-0 bottom-2 text-[10px] font-black text-slate-300 tracking-[0.3em]">
                    HITS
                  </span>
                </div>
              </div>
            ) : (
              <></>
            )}
            {/* Input 04 */}
            {isAdmin ? (
              <div className="p-10 md:p-12 space-y-6 group">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-amber-50 rounded-xl flex items-center justify-center text-amber-600 shadow-sm">
                    <FiDatabase />
                  </div>
                  <label className="text-xs font-black text-slate-400 uppercase tracking-widest">
                    Tapo API Rate Limit <p>(Do not change for testing — may affect
                    scheduled APIs)</p>
                  </label>
                </div>
                <div className="relative">
                  <input
                    type="number"
                    value={tapoRateLimit}
                    onChange={(e) => setTapoRateLimit(e.target.value)}
                    className="w-full bg-transparent border-none p-0 font-black text-6xl text-slate-800 focus:ring-0 outline-none placeholder:text-slate-100"
                    placeholder="00"
                  />
                  <span className="absolute right-0 bottom-2 text-[10px] font-black text-slate-300 tracking-[0.3em]">
                    limit/sec
                  </span>
                </div>
              </div>
            ) : (
              <></>
            )}

            {/* Input 05 */}
            {isAdmin ? (
              <div className="p-10 md:p-12 space-y-6 group">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-amber-50 rounded-xl flex items-center justify-center text-amber-600 shadow-sm">
                    <FiDatabase />
                  </div>
                  <label className="text-xs font-black text-slate-400 uppercase tracking-widest">
                    Honeywell API Rate Limit <p>(Do not change for testing — may
                    affect scheduled APIs)</p>
                  </label>
                </div>
                <div className="relative">
                  <input
                    type="number"
                    value={honeywellRateLimit}
                    onChange={(e) => setHoneywellRateLimit(e.target.value)}
                    className="w-full bg-transparent border-none p-0 font-black text-6xl text-slate-800 focus:ring-0 outline-none placeholder:text-slate-100"
                    placeholder="00"
                  />
                  <span className="absolute right-0 bottom-2 text-[10px] font-black text-slate-300 tracking-[0.3em]">
                    limit/min
                  </span>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>

          {/* FOOTER ACTION */}
          <div className="bg-slate-50/80 p-8 flex flex-col md:flex-row items-center justify-between gap-6 border-t border-slate-100">
            <button
              onClick={handleSave}
              disabled={saving}
              className={`w-full md:w-auto px-12 py-5 rounded-2xl font-black text-xs tracking-[0.2em] uppercase transition-all active:scale-95 shadow-xl flex items-center justify-center gap-3 ${
                success
                  ? "bg-emerald-500 text-white shadow-emerald-200"
                  : "bg-slate-900 text-white hover:bg-indigo-600 shadow-indigo-200"
              }`}
            >
              {saving ? (
                <FiLoader className="animate-spin" />
              ) : success ? (
                <FiCheckCircle />
              ) : (
                <FiSave />
              )}
              {saving ? "SYNCING..." : success ? "UPDATING" : "UPDATE SETTINGS"}
            </button>
          </div>

          {/* --- SYSTEM MONITORING DASHBOARD --- */}
          <div className="bg-slate-50/50 p-8 md:p-12 border-t border-slate-100">
            <h3 className="text-[14px] font-black text-slate-400 uppercase tracking-[0.3em] flex items-center gap-2 mb-8 px-2">
              <FiCpu className="text-indigo-500" /> System Health Monitor
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {/* RAM & Status */}
              <div className="bg-white p-6 rounded-3xl shadow-sm border border-slate-100 space-y-4">
                <div className="flex justify-between items-start">
                  <div className="p-3 bg-blue-50 rounded-2xl text-blue-600 shadow-sm">
                    <FiHardDrive />
                  </div>
                  <div
                    className={`px-3 py-1 rounded-full text-[9px] font-black uppercase tracking-tighter ${systemInfo.systemStatus === "throttled" ? "bg-amber-100 text-amber-700" : "bg-emerald-100 text-emerald-700"}`}
                  >
                    {systemInfo.systemStatus}
                  </div>
                </div>
                <div>
                  <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                    RAM Usage
                  </p>
                  <h5 className="text-xl font-black text-slate-800">
                    {systemInfo.lastRamCheck}
                  </h5>
                </div>
                <p className="text-[9px] font-bold text-slate-500 italic leading-tight">
                  {systemInfo.statusReason}
                </p>
              </div>

              {/* Cron Status */}
              <div className="bg-white p-6 rounded-3xl shadow-sm border border-slate-100 space-y-4">
                <div className="flex justify-between items-start">
                  <div className="p-3 bg-indigo-50 rounded-2xl text-indigo-600 shadow-sm">
                    <FiActivity />
                  </div>
                  <div
                    className={`w-3 h-3 rounded-full ${getStatusColor(systemInfo.lastPulse, systemInfo.cronActive)}`}
                  />
                </div>
                <div>
                  <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                    Cron Service
                  </p>
                  <h5
                    className={`text-xl font-black ${
                      isServiceActive(
                        systemInfo.lastPulse,
                        systemInfo.cronActive,
                      )
                        ? "text-emerald-600"
                        : "text-red-600"
                    }`}
                  >
                    {isServiceActive(
                      systemInfo.lastPulse,
                      systemInfo.cronActive,
                    )
                      ? "ACTIVE"
                      : "INACTIVE"}
                  </h5>
                </div>
                <div className="pt-2 border-t border-slate-50">
                  <p className="text-[10px] font-bold text-slate-400">
                    Last Pulse:
                  </p>
                  <p className="text-[10px] font-black text-slate-800 uppercase tracking-tighter">
                    {systemInfo.lastPulse
                      ? new Date(systemInfo.lastPulse).toLocaleString()
                      : "N/A"}
                  </p>
                </div>
              </div>

              {/* Worker Status */}
              <div className="bg-white p-6 rounded-3xl shadow-sm border border-slate-100 space-y-4">
                <div className="flex justify-between items-start">
                  <div className="p-3 bg-violet-50 rounded-2xl text-violet-600 shadow-sm">
                    <FiZap />
                  </div>
                  <div
                    className={`w-3 h-3 rounded-full ${getStatusColor(systemInfo.workerLastPulse, systemInfo.workerActive)}`}
                  />
                </div>
                <div>
                  <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                    Worker Node
                  </p>
                  <h5
                    className={`text-xl font-black ${
                      isServiceActive(
                        systemInfo.workerLastPulse,
                        systemInfo.workerActive,
                      )
                        ? "text-emerald-600"
                        : "text-red-600"
                    }`}
                  >
                    {isServiceActive(
                      systemInfo.workerLastPulse,
                      systemInfo.workerActive,
                    )
                      ? "ACTIVE"
                      : "INACTIVE"}
                  </h5>
                </div>
                <div className="pt-2 border-t border-slate-50">
                  <p className="text-[10px] font-bold text-slate-400">
                    Last Pulse:
                  </p>
                  <p className="text-[10px] font-black text-slate-800 uppercase tracking-tighter">
                    {systemInfo.workerLastPulse
                      ? new Date(systemInfo.workerLastPulse).toLocaleString()
                      : "N/A"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .no-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .no-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        input[type="number"]::-webkit-inner-spin-button,
        input[type="number"]::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
      `}</style>
    </div>
  );
};

export default Setting;
